import Blockly from "blockly";
import helpers from "blocks/helpers";

Blockly.Blocks.ChangeX = {
  message0: "change x by %1",
  args0: [
    {
      type: "input_value",
      name: "x",
      check: "Number",
    },
  ],
  previousStatement: "Statement",
  nextStatement: "Statement",
};

Blockly.Blocks.ChangeX.init = function () {
  this.jsonInit(Blockly.Blocks.ChangeX);
};

Blockly.JavaScript.ChangeX = function (block) {
  const x = helpers.codeForArg("x", block);

  if (typeof x === "undefined") {
    return "";
  } else {
    return `visualisation.changeX(${x});`;
  }
};
